<template lang="pug">
  #app-conversas-assunto
    el-card(shadow="hover")
      p.bolder Filtros
      el-row.margin-left
        el-col(:xs="12" :lg="7" :xl ="7" :sm="13")
          InputEntreDatas(
            placeholder="Período"
            :calendario="calendario"
            v-model="calendario"
          )
        el-col(:xs="24" :lg="6" :xl ="8" :sm="11")
          p Status
          el-select(
            v-model="filtro.status"
            multiple
            collapse-tags
            filterable
            clearable
          )
            el-option(
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
        el-col(:xs="24" :lg="8" :xl ="8" :sm="12")
          p Responsável
          el-select(
            v-model="filtro.idsResponsaveis"
            multiple
            collapse-tags
            filterable
            clearable
          )
            el-option(
              v-for="item in responsaveis"
              :key="item.pessoa.pessoaFisica.id"
              :label="item.pessoa.pessoaFisica.nome"
              :value="item.pessoa.pessoaFisica.id"
            )
      el-row.margin.float
        el-button(
          type="text"
          size="medium"
          round
          @click="handleLimpar"
        ) Limpar
        el-button(
          type="primary"
          size="medium"
          round
          @click="handleFiltrar"
        ) Filtrar
    //- Adicionado component de grafico por assunto
    //- Adicionado el-card em volta da tabela ou grafico
    el-card(shadow="hover")#graficoId.content-dados
      GraficoAssunto(
        v-if="acaoCondicao"
        :dadosLabels="dadosFiltro"
      )
      //- tirei o template e coloquei direto no component a condição
      app-listagem-conversas.custom-tabela(
        v-else
        :data="dadosFiltro"
        :colunaChave="nomeColuna"
        :totalDeConversas="totalDeConversas"
        emptyData = "Não há dados registrados"
      )
    el-row
      BotaoSelecionar.center(
        @btn-0="selecionar('acao-1')"
        @btn-1="selecionar('acao-2')"
        botao0="Gráficos"
        botao1="Tabela"
      )
    //- Componente com logica de exportar selecionado
    el-row.botao-exportar.float
      BotaoExportarSelecionado(
        @exportar-img-grafico="exportarImgGrafico"
        :dadosFiltro="filtro"
        :selecionadoCondicao="acaoCondicao"
        :disabled="botaoExportarDesligado"
        tab="assunto"
        :carregando="isLoading"
      )
</template>

<script>
import { mapActions } from 'vuex'
import domtoimage from 'dom-to-image'
import moment from 'moment'

import AppNotificacao from '@/components/mixins/AppNotificacao'
import InputEntreDatas from '../InputEntreDatas'
import BotaoSelecionar from '../BotaoSelecionar'
import GraficoAssunto from '../graficos/GraficoAssunto'
import BotaoExportarSelecionado from '../BotaoExportarSelecionado'
import AppListagemConversas from '../AppListagemConversas'
import { status } from './nomesEstaticos'

export default {
  name: 'AppConversasStatus',
  mixins: [
    AppNotificacao
  ],
  components: {
    InputEntreDatas,
    AppListagemConversas,
    BotaoSelecionar,
    BotaoExportarSelecionado,
    GraficoAssunto
  },

  data () {
    // Apaguei alguns atributos não utilizados e criei o 'totalDeConversas'
    return {
      nomeColuna: 'Assunto',
      acaoCondicao: true,
      calendario: [],
      responsaveis: [],
      status: [],
      dadosFiltro: [],
      botaoExportarDesligado: false,
      filtro: {
        dataInicio: null,
        dataFim: null,
        status: [],
        idsResponsaveis: []
      },
      totalDeConversas: 0,
      totalFiltrado: 0,
      isLoading: false
    }
  },

  methods: {
    ...mapActions({
      findResponsaveis: 'filtros/findResponsaveis',
      filtrarPorAssunto: 'filtros/filtrarPorAssunto'
    }),

    selecionar (acao) {
      if (acao === 'acao-1') {
        this.acaoCondicao = true
      } else {
        this.acaoCondicao = false
      }
    },

    handleLimpar () {
      this.calendario = []
      this.filtro = {
        dataInicio: null,
        dataFim: null,
        status: [],
        idsResponsaveis: []
      }
      this.getAssuntos().then(() => this.seNaoHaDados())
    },

    // função para exportar o grafico como imagem
    exportarImgGrafico () {
      this.isLoading = true
      const dataConsulta = moment().format('DD-MM-YYYY_hh:mm:ss')
      domtoimage.toBlob(document.getElementById('graficoId'))
        .then((blob) => {
          window.saveAs(blob, `Grafico_Assunto_${dataConsulta}.png`)
          this.isLoading = false
        })
    },
    // verifica se ha dados em todos elementos do array dadosFiltro
    seNaoHaDados () {
      if (this.dadosFiltro.every(elem => elem.quantidade === 0)
      ) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Nenhuma conversa encontrada neste período.')
        this.botaoExportarDesligado = true
      } else {
        this.botaoExportarDesligado = false
      }
    },
    // adicionado mais uma condição para que possa filtrar sem o periodo selecionado
    async handleFiltrar () {
      if (
        this.calendario <= 0 &&
        this.filtro.status <= 0 &&
        this.filtro.idsResponsaveis <= 0
      ) {
        this.dadosFiltro = await this.filtrarPorAssunto()
        this.seNaoHaDados()
      } else if (
        this.calendario <= 0 &&
        !this.filtro.status <= 0 &&
        !this.filtro.idsResponsaveis <= 0
      ) {
        this.dadosFiltro = await this.filtrarPorAssunto(this.filtro)
        this.seNaoHaDados()
      } else {
        this.filtro.dataInicio = moment(this.calendario[0]).format('yyyy-MM-DD')
        this.filtro.dataFim = moment(this.calendario[1]).format('yyyy-MM-DD')
        this.dadosFiltro = await this.filtrarPorAssunto(this.filtro)
        this.seNaoHaDados()
      }
      let totalFiltrado = 0
      for (let i = 0; i < this.dadosFiltro.length; i++) {
        totalFiltrado += this.dadosFiltro[i].quantidade
      }
      this.totalDeConversas = totalFiltrado
      if (this.totalDeConversas === 0) {
        this.dadosFiltro = []
      }
    },

    async getResponsaveis () {
      this.responsaveis = await this.findResponsaveis()
    },

    // Alterei esse método pra pegar todas as conversas.
    async getAssuntos () {
      this.totalDeConversas = 0
      this.dadosFiltro = await this.filtrarPorAssunto()
      for (let i = 0; i < this.dadosFiltro.length; i++) {
        this.totalDeConversas += this.dadosFiltro[i].quantidade
      }
    }
  },

  created () {
    this.status = status
  },

  mounted () {
    this.getResponsaveis()
    this.getAssuntos()
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

 .margin {
    margin: 1.5rem 2rem 1.5rem;
  }

  .margin-left {
    margin-left: 0.3rem;
  }

  .margin-top {
    margin-top: 6rem;
  }

  .botao-exportar {
    margin: 1.5rem 2rem 0.5rem;
  }

  .content-dados {
    margin-top: 1rem ;
    height: 24rem;
    width: 100%;
  }

  /deep/ .cell {
    color: #424242;
  }

  .float {
    float: right;
  }

  .center {
    display:flex;
    position:absolute;
    left: auto;
    right: 45%;
    top: -1.3rem;
  }

  .bolder {
    font-weight: bolder;
  }

  .custom-tabela{
    border-top-width: 2px;
    border-top-style: solid;
    border-top-color: $border-color;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/components/conversas/AppConversasAssunto.vue